import instance from '@apis/instance';

class MyShopApi {
    static toggleMyShop(shopId: string): Promise<never> {
        return instance.put(`/v0/my-shop/${shopId}`);
    }
}

export default MyShopApi;
